import React from 'react';

function Index(props) {
    return (
        <div></div>
    );
}

export default Index;